<template>
    <article>
        <icon-logo-graphic class="w-full h-[154px] pb-6"/>
        <p class="text-grey-70 pb-2">Agency Central is the UK's leading recruitment agency directory,
            supporting candidates and employers who wish to use the services of an employment
            agency.</p>
        <p class="text-grey-70 pb-2">Our site features an advanced search and filter system which finds
            the agencies which match your needs. Each agency we list includes information unique to
            Agency Central.</p>
        <p class="text-grey-70 pb-2">We also provide unique information on salaries as your career
            progresses and UK region comparisons. Finally, we have guides to help you land your perfect
            job and for the recruitment agencies, a
            <static-search-link class="text-blue-30" to="/social-leaderboards">Social
                Leaderboard
            </static-search-link>
            to see who are the biggest social influencers.
        </p>
        <p class="text-grey-70">Use the search above to get started.</p>
    </article>
</template>

<script>
import IconLogoGraphic from "Components/Icons/IconLogoGraphic";
import StaticSearchLink from "../StaticSearchLink.vue";

export default {
    name: "AboutAgencyCentralInfo",
    components: {IconLogoGraphic, StaticSearchLink}
}
</script>
